import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { styled } from '../../styles';
import { useSaveUpdateButton } from '../../hooks/notes/use_save_update_button';
import { Button } from '../buttons/button';
export function SaveUpdateButton() {
    const { onClick, textToDisplay, disabled } = useSaveUpdateButton();
    return (_jsx(SaveUpdateButtonComponent, { textToDisplay: textToDisplay, onClick: onClick, disabled: disabled }));
}
function SaveUpdateButtonComponent({ textToDisplay, onClick, disabled, }) {
    return (_jsx(SaveUpdateStyledButton, { variant: "primary", onClick: onClick, fontSize: "small", disabled: disabled, "data-testid": "notes-save-update-button", children: textToDisplay }));
}
const SaveUpdateStyledButton = styled(Button)(({ theme }) => ({
    borderColor: theme.colors.blue50,
    height: '2.125rem',
    width: '5.625rem',
}));
//# sourceMappingURL=save_update_button.js.map